import { customElement, property } from 'lit/decorators';

import { Select } from '@material/mwc-select';
import { css } from 'lit';
import { isDefined } from '../../helpers/utils';

@customElement('proxi-selectfield')
export class ProxiSelectfield extends Select {

    @property({ type: String }) height: string = '2rem';

    static get styles() {
        return [
            ...Select.styles,
            css`
                :host {
                    width: 100%;
                    --mdc-menu-item-height: var(--select-height, 2.5rem);
                    --mdc-notched-outline-border-color: var(--main-primary-color);
                    --mdc-select-outlined-idle-border-color: var(--main-primary-color);
                    --mdc-typography-subtitle1-font-size: 12px;
                }

                ..mdc-select--outlined .mdc-select__anchor {
                    padding-left: 0.5rem;
                }

                .mdc-select--outlined .mdc-select--filled .mdc-select__anchor {
                    height: var(--select-height, 2.5rem) !important;
                    width: 100%;
                }

                .mdc-select__dropdown-icon {
                    padding-left: 4px;
                    padding-right: 4px;
                }

                .custom-select-anchor {
                    height: var(--select-height, 2.5rem) !important;
                    width: 100% !important;
                }

                .mdc-select__anchor {
                    height: var(--select-height, 2.5rem) !important;
                    width: 100% !important;
                }

                .mdc-text-field-helper-line {
                    height: 0;
                }

                .mdc-floating-label {
                    transform: translateY(-50%) scale(0.75); /* Adjust the label position */
                }

                .mdc-text-field--outlined .mdc-floating-label {
                    transform: translateY(-1.5rem) scale(0.75); /* Adjust the label position for outlined variant */
                    background: white;
                }

                .mdc-select--outlined .mdc-select__anchor .mdc-floating-label--float-above {
                    transform: translateY(-1.5rem) scale(0.75); /* Adjust the label position when floating for outlined variant */
                }

                .mdc-notched-outline {
                    height: var(--textfield-height, 2rem);
                }

                .mdc-notched-outline__notch {
                    padding: 0;
                    width: auto !important;
                }
            `
        ];
    }

    async firstUpdated() {
        await super.firstUpdated();

        const selectAnchor = this.shadowRoot?.querySelector('.mdc-select__anchor') as HTMLElement;
        if (isDefined(selectAnchor)) {
            selectAnchor.classList.add('custom-select-anchor');
        }
    }

    updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('height')) {
            this.style.setProperty('--select-height', this.height);
            this.style.setProperty('--textfield-height', this.height);
        }
    }
}
